"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationSetting_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var LocationSetting_Factory = /** @class */ (function () {
    function LocationSetting_Factory() {
    }
    LocationSetting_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Key: model.Key,
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            Value: model.Value,
        };
        return result;
    };
    LocationSetting_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Key: model.Key,
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            Value: model.Value,
        };
        return result;
    };
    return LocationSetting_Factory;
}());
exports.LocationSetting_Factory = LocationSetting_Factory;
